module.exports = __webpack_public_path__ + "static/fonts/idtroc.50ec5b1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idtroc_font/fonts/idtroc.woff?j0czor
// module id = ZvCO
// module chunks = 1